module.exports = __webpack_public_path__ + "static/block3-2d81ea16da46e0450a213297039a5fc4.jpg";